import styled, { css } from "styled-components";
import COLORS from "../../constants/colors";
import Flex from "../../layout/Flex";
import { RadioProps } from "./Radio.types";

export const StyledRadioWrapper = styled(Flex)<
    Pick<RadioProps, "diskPosition" | "disabled">
>`
    gap: 10px;
    align-items: flex-start;
    padding: 8px;

    ${({ diskPosition }) => {
        if (diskPosition === "end") {
            return css`
                justify-content: space-between;
            `;
        }
    }}
    label {
        cursor: pointer;
        ${({ disabled }) => (disabled ? `cursor: default;` : ``)}
    }
`;

export const StyledRadioTextWrapper = styled(Flex)`
    gap: 0.5em;
`;

export const StyledRadio = styled.input<Partial<RadioProps>>`
    appearance: none;
    -webkit-appearance: none;
    border-radius: 50%;
    border: 2px solid ${COLORS.WHITE};
    background-color: ${COLORS.WHITE};
    box-shadow: 0 0 0 2px ${COLORS.GREY_300};
    min-height: 14px;
    min-width: 14px;
    margin: 2px 0;
    margin-top: 4px;

    ${({ diskPosition }) => {
        if (diskPosition === "end") {
            return css`
                order: 1;
            `;
        }
    }}

    &:checked {
        box-shadow: 0 0 0 2px ${({ fillColor }) => fillColor};
        background-color: ${({ fillColor }) => fillColor};
    }

    ${({ actionable }) =>
        actionable &&
        css`
            cursor: pointer;
            &:checked:disabled {
                background-color: ${COLORS.GREY_600};
            }
            &:disabled {
                box-shadow: 0 0 0 2px ${COLORS.GREY_600};
                cursor: not-allowed;
            }
        `}
`;
